import { Box, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const ProgressSpinner = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100vh"
      bg="secondary.800"
      color="primary.100"
      p={4}
    >
      <Spinner
        thickness="16px"
        speed="2s"
        emptyColor="primary.700"
        color="cyberpunk.purple"
        size="xl"
        mb={4}
      />
      <Text fontSize="xl">{t("Loading data")}</Text>
    </Box>
  );
};

export default ProgressSpinner;
